import { Avatar, Card, Flex, Typography } from 'antd';
import React from 'react';

import type { TelegramAccountProps } from 'features/user/interfaces';

import { getSrc } from '../../../../../utils/common/getSrc';

const { Title } = Typography;

export const TelegramAccount = ({
    first_name,
    last_name,
    photo_url,
}: TelegramAccountProps) => {
    const name = `${first_name ?? ''} ${last_name ?? ''}`;

    return (
        <Card type='inner' style={{ width: '288px', maxWidth: '100%' }}>
            <Flex gap={24} align={'center'}>
                <Avatar size={'large'} src={getSrc(photo_url)} />
                <div>
                    <Title
                        style={{
                            margin: 0,
                        }}
                        level={5}
                    >
                        {name}
                    </Title>
                    {/*<RemoveTelegramAccount*/}
                    {/*    name={name}*/}
                    {/*    photo_url={img_url}*/}
                    {/*    telegram_id={props.account.telegram_id}*/}
                    {/*/>*/}
                </div>
            </Flex>
        </Card>
    );
};
